export default "__VITE_ASSET__51301a6f__"